import React from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; // Importa SweetAlert2
import { ROL_ADMIN } from '../../helpers/variables.helper';

function AuthComponent({ children }) {
    const navigate = useNavigate();

    // Obtén el token y el rol directamente como cadenas
    const token = sessionStorage.getItem("token") || ""; 
    const rolUsuario = sessionStorage.getItem("rol") || "";

    if (!token) {
        // Muestra una alerta de SweetAlert2
        Swal.fire({
            icon: 'warning',
            title: 'Acceso requerido',
            text: 'Para ingresar a este servicio, por favor inicia sesión con tu cuenta.',
            confirmButtonText: 'Entendido',
        }).then(() => {
            // Redirige al usuario después de cerrar la alerta
            navigate("/agroh_panel");
        });
    } else if (parseInt(rolUsuario) === ROL_ADMIN) {
        return children;
    } else {
        // Muestra una alerta de SweetAlert2 para credenciales insuficientes
        Swal.fire({
            icon: 'error',
            title: 'Acceso denegado',
            text: 'No posees las credenciales suficientes para acceder a este servicio.',
            confirmButtonText: 'Volver al inicio',
        }).then(() => {
            // Redirige al usuario después de cerrar la alerta
            navigate("/");
        });
    }
}

export default AuthComponent;
